import { render } from "./LoadOrderList.vue?vue&type=template&id=b5f653d0&scoped=true"
import script from "./LoadOrderList.vue?vue&type=script&lang=js"
export * from "./LoadOrderList.vue?vue&type=script&lang=js"

import "./LoadOrderList.vue?vue&type=style&index=0&id=b5f653d0&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f653d0"]])

export default __exports__